// extracted by mini-css-extract-plugin
export default {"wrapper":"Maps_wrapper__njxiA","maps_wrapper":"Maps_maps_wrapper__A1ybo"};